import { createSelector } from 'reselect'
import { selectTemplates } from './selectTemplates'

export const selectCannedReplyTemplatesTotalCountOrNull = createSelector(
  selectTemplates,
  templates => templates.totalCount
)
